import { AxiosInstance } from 'axios';
import { classToPlain } from 'class-transformer';
import { ClassType } from 'class-transformer/ClassTransformer';

import { Count } from '../models/count.model';
import { Page } from '../models/page.model';
import { BaseService } from './base.service';

export class CrudService<T> extends BaseService {

	constructor(http: AxiosInstance) {
		super(http);
	}

	getAll(entityClass: ClassType<T>, entityName: string, extraRest?: string): Promise<T[]> {
		const url = !extraRest ? `/ws/${entityName}` : `/ws/${entityName}/${extraRest}`;
		return this.mapResponse<T[]>(this.http.get(url), entityClass);
	}

	getCount(entityClass: ClassType<T>, entityName: string): Promise<Count> {
		return this.mapResponse<Count>(this.http.get(`/ws/${entityName}/count`), entityClass);
	}

	getEntity(entityClass: ClassType<T>, entityName: string, id: number): Promise<T> {
		return this.mapResponse<T>(this.http.get(`/ws/${entityName}/${id}`), entityClass);
	}

	saveEntity(entityClass: ClassType<T>, entityName: string, entity: any): Promise<T> {
		return this.mapResponse<T>(this.http.put(`/ws/${entityName}/${entity.id}`, classToPlain(entity)), entityClass);
	}

	createEntity(entityClass: ClassType<T>, entityName: string, entity: any): Promise<T> {
		return this.mapResponse<T>(this.http.post(`/ws/${entityName}`, classToPlain(entity)), entityClass);
	}

	deleteEntity(entityClass: ClassType<T>, entityName: string, entity: any): Promise<T> {
		return this.mapResponse<T>(this.http.delete(`/ws/${entityName}/${entity.id}`), entityClass);
	}

	searchEntities(entityClass: ClassType<T>, entityName: string, search: any, page: Page): Promise<T[]> {
		return this.mapResponse<T[]>(this.http.post(`/ws/${entityName}/advancedsearch/${page.start}/${page.stop}`, classToPlain(search)), entityClass);
	}

	csvExport(entityName: string, search: any, page: Page): Promise<T[]> {
		return this.mapResponse<T[]>(this.http.post(`/ws/${entityName}/csvexport/${page.start}/${page.stop}`, classToPlain(search), { responseType: 'blob' }));
	}

	countEntities(entityClass: ClassType<T>, entityName: string, search: any): Promise<Count> {
		return this.mapResponse<Count>(this.http.post(`/ws/${entityName}/advancedcount`, classToPlain(search)), entityClass);
	}

	uploadEntity(entityClass: ClassType<T>, entityName: string, entityid: number, postObj: any): Promise<T> {
		return this.mapResponse<T>(this.http.post(`/ws/upload/${entityName}/${entityid}`, postObj, {
			headers: {
				// Accept: '*',
				'Content-Type': 'multipart/form-data',
			}
		}), entityClass);
	}

}
